import { NavigationProp } from '@react-navigation/native';

export const navigateToCocktailsWithSearch = (
  navigation: any,
  searchTerm: string
) => {
  console.log('🧭 Navigating to Cocktails with search term:', searchTerm);
  navigation.navigate('Cocktails', { searchTerm });
};
